<template>
  <div class="modal"
    :class="{'is-active': active, 'is-modal-xlarge is-modal-fullHeight': device == 'desktop'}"
  >
    <div class="modal-background" @click.prevent.stop="close"></div>
    <div class="modal-card">
      <div class="row-width-actions-bar">
        <div class="columns is-gapless is-vcentered is-border-bottom">
          <div class="column is-padding-left">
            <div class="has-text-dark is-size-6 is-uppercase">
              <span class="has-text-weight-medium">{{params.title || 'Documents'}}</span>
            </div>
          </div>
          <div class="column is-narrow is-border-left">
            <a class="page-header-btn is-small is-square" @click="close">
              <span class="icon is-size-4 has-text-dark"><i class="fal fa-times"></i></span>
            </a>
          </div>
        </div>
      </div>
      <section class="modal-card-body is-clipped">
        <form @submit.prevent.stop="" class="columns is-gapless is-column is-min-height-full">
          <div class="column"
            v-if="device == 'desktop'"
          >
            <!-- <spinner-round :isLoading="loading" v-if="!errorMessage"></spinner-round> -->
            <embed
                    id="embed"
                    :src="link"
                    width="100%"
                    height="100%"
                    style="border: none; min-height: calc(100vh - 150px)"
                    type="application/pdf"><!-- HB : minHeight obligé pour safari (desktop et tablette) -->
          </div>
          <div class="column is-narrow columns is-gapless is-centered has-bg-white is-padding-top-small is-padding-bottom-small">
            <div class="column"
              :class="[device == 'desktop' ? 'is-4' : 'is-5']"
            >
              <button @click="download()" class="button is-transform-none is-success is-full">
                <span>Télécharger contrat</span>
                <span class="icon">
                      <i class="fas fa-download"></i>
                  </span>
              </button>
            </div>
            <div v-if="isAdmin || (advDossier && 'is_digital' in advDossier && advDossier.is_digital)"
              class="column is-margin-left-small"
              :class="[device == 'desktop' ? 'is-4' : 'is-5']"
            >
              <button @click="signer()" class="button is-transform-none is-success is-full">
                <span>Aller a l'étape de signature</span>
                <span class="icon">
                      <i class="fas fa-signature"></i>
                  </span>
              </button>
            </div>
          </div>
        </form>
      </section>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name: 'DossierResa',
    data () {
      return {
        errorCount: 0,
        interval: null,
        errorMessage: false,
        loading: false
      }
    },
    props: {
      link: {
        type: String
      },
      buyersDossier: {
        type: Object
      },
      active: {
        type: Boolean,
        required: true
      },
      params: {
        type: Object
      },
      advDossier: {
        type: Object
      }
    },
    computed: {
      ...mapState(['device']),
      name () {
        let name = 'contrat-resa-ADV.' + this.params.adv.ref
        if (this.buyersDossier.length !== 0) {
          this.buyersDossier.forEach(buyer => {
            name = name + '-' + buyer.last_name
          })
        }
        name = name + '.pdf'
        return name
      }
    },
    methods: {
      download () {
        const link = document.createElement('a')
        link.href = this.link
        link.setAttribute('target', '_blank')
        link.setAttribute('download', this.name)
        document.body.appendChild(link)
        link.click()
      },
      close () {
        this.$emit('close')
      },
      signer () {
        this.$emit('goToSign')
      }
    },
    created () {
      console.log(this.params)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/modal/DossierResa.vue